import type { OrganizationStatus } from '@server/orbit/helpers/organization'

type Tone = 'live' | 'pending' | 'failed' | 'idle'
type BadgeVariant = 'success' | 'warning' | 'neutral'

const STATUS: Record<OrganizationStatus, { label: string; tone: Tone; badge: BadgeVariant }> = {
  live: { label: 'Live', tone: 'live', badge: 'success' },
  trial: { label: 'Free trial', tone: 'live', badge: 'success' },
  payment_required: { label: 'Payment required', tone: 'pending', badge: 'warning' },
  setting_up: { label: 'Setting up', tone: 'pending', badge: 'warning' },
  not_set_up: { label: 'Not set up', tone: 'idle', badge: 'neutral' }
}

export const organizationStatusMeta = (status: OrganizationStatus | undefined) => STATUS[status ?? 'not_set_up']

export const isLiveStatus = (status: OrganizationStatus) => status === 'live' || status === 'trial'
